import { render, staticRenderFns } from "./FlexibleBall.vue?vue&type=template&id=f73fa536"
import script from "./FlexibleBall.vue?vue&type=script&lang=js"
export * from "./FlexibleBall.vue?vue&type=script&lang=js"
import style0 from "./FlexibleBall.vue?vue&type=style&index=0&id=f73fa536&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports